import { Box, CircularProgress } from '@mui/material';
import type { ReactNode } from 'react';
import { AuthErrorPage } from './AuthErrorPage';
import { useAuth } from './AuthProvider';

type AuthGateProps = {
  children: ReactNode;
};

export const AuthGate = ({ children }: AuthGateProps) => {
  const { isAuthenticated, isLoading, error } = useAuth();

  if (isLoading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress size={48} />
      </Box>
    );
  }

  if (error) {
    return <AuthErrorPage />;
  }

  if (!isAuthenticated) {
    // This should not happen as AuthProvider redirects, but just in case
    return null;
  }

  return <>{children}</>;
};
